module.exports = __webpack_public_path__ + "img/bathroom-full.6060845e.jpg";